import React from 'react';

// Mandate stage chip with a coloured dot prefix.  Tone for each stage mirrors
// the prototype's mapping in app.jsx (StageChip component).

const TONES: Record<string, string> = {
  Execution: 'info',
  'Pre-listing': 'info',
  Implementation: 'warn',
  Closing: 'success',
  Reporting: 'info',
  Structuring: 'warn',
  'Field Work': 'muted',
  'Due Diligence': 'warn',
  Closed: 'success'
};

interface Props {
  stage: string;
}

const StageChip = ({ stage }: Props) => {
  const tone = TONES[stage] || 'muted';
  return <span className={`chip dot ${tone}`}>{stage}</span>;
};

export default StageChip;
